export const getFilename = (name: string, path: string, file: File | null) => {
  try {
    return `${path}${name}.${file?.name?.split('.')[1]}`;
  } catch (error) {
    console.error('Error uploading file:', error);
    return null;
  }
};
